(function () {
    angular
        .module("app")
        .config(routeConfig);

    function routeConfig($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise("/");

        $stateProvider
            .state('search', {
                url: '/?q&v&f$tab$page',
                templateUrl: 'pages/search_results/search_results.html',
                controller: 'SearchResultsController',
                primary:true
            });
    }
})();
